import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { PaginacionComponent } from '../../../../core/components/paginacion/paginacion.component';
import { NotificacionesStore } from '../../services/notificaciones.store';
import { NotificacionInstitucional, TipoEntrega, formatearFechaHoraArgentina } from '../../models/notificacion-institucional.model';

@Component({
  selector: 'app-notificaciones',
  standalone: true,
  imports: [RouterLink, PaginacionComponent],
  templateUrl: './notificaciones.component.html',
  styleUrl: './notificaciones.component.scss'
})
export class NotificacionesComponent {
  readonly store = inject(NotificacionesStore);
  private readonly router = inject(Router);

  readonly formatearFecha = formatearFechaHoraArgentina;

  readonly filtroTipoEntrega = signal<'' | TipoEntrega>('');
  readonly filtroNombre = signal('');
  readonly filtroIncluirEliminadas = signal(false);

  constructor() {
    this.store.reiniciar();
  }

  buscar(): void {
    this.store.setFiltros({
      tipoEntrega: this.filtroTipoEntrega() || undefined,
      nombreInterno: this.filtroNombre().trim() || undefined,
      incluirEliminadas: this.filtroIncluirEliminadas()
    });
  }

  // Click en una fila navega a la pantalla completa de editar/consulta — ya
  // no abre un modal (ver docs/specs/abmc-notificacion-institucional.md §3.3,
  // corrección post-implementación #5). El propio NotificacionNuevaComponent
  // decide el modo (editar/consulta) según `editable` del detalle que pide.
  abrirFila(n: NotificacionInstitucional): void {
    this.router.navigate(['/notificaciones', n.id, 'editar']);
  }

  // Solo hay auditoría si la notificación ya se envió (fechaEnvio seteado).
  abrirAuditoria(n: NotificacionInstitucional): void {
    this.router.navigate(['/auditoria', n.id]);
  }

  onCambiarPagina(pagina: number): void {
    this.store.cambiarPagina(pagina);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onCambiarTamanoPagina(tamano: number): void {
    this.store.cambiarTamanoPagina(tamano);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
